import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';

const useRouteClass = (): void => {
  const location = useLocation();

  useEffect(() => {
    const html = document.documentElement; // <html> element

    // Convert path to class-friendly string
    const path: string =
      location.pathname
        .replace(/^\//, '') // remove leading slash
        .replace(/\//g, '-') || // replace nested routes with dash
      'home';

    const className: string = `page-${path}`;

    // Remove old route classes
    html.classList.forEach((cls: string) => {
      if (cls.startsWith('page-')) {
        html.classList.remove(cls);
      }
    });

    // Add new class
    html.classList.add(className);

    // Cleanup
    return () => {
      html.classList.remove(className);
    };
  }, [location.pathname]);
};

export default useRouteClass;
